import Checkbox from '@oncolens/oncolens-ui/lib/components/FormControls/Checkbox';
import TextAreaInput from '@oncolens/oncolens-ui/lib/components/FormControls/TextAreaInput';
import FormField from '@oncolens/oncolens-ui/lib/libraries/FormField';
import React from 'react';
import RequestSection from '../../RequestSection';
import store from '@/features/requests/components/NewRequest/Templates/osu/store';

const SubmitToSection = () => {
  return (
    <RequestSection title="1. Enter reason for request">
      <div className="grid items-center gap-3 sm:grid-cols-3">
        <div className="self-end">
          <FormField name="submitTo.highPriority" store={store}>
            {({ onChange, value }) => (
              <Checkbox
                id="highPriority"
                htmlName="highPriority"
                label="High Priority"
                value={value}
                inputProps={{ onChange: onChange, checked: value }}
              />
            )}
          </FormField>
        </div>
        <FormField name="submitTo.reasonsForRequest" store={store}>
          {({ onChange, value, errorMessage }) => (
            <TextAreaInput
              id="reasonsForRequest"
              label="Reason for request"
              htmlName="reasonsForRequest"
              required={true}
              value={value}
              onChange={onChange}
              error={errorMessage}
              wrapperProps={{ className: 'sm:col-span-3' }}
            />
          )}
        </FormField>
      </div>
    </RequestSection>
  );
};

export { SubmitToSection as default };
